export default function () {
	let openCtrl = document.getElementById('btn-search'),
		closeCtrl = document.getElementById('btn-search-close'),
		searchContainer = document.querySelector('.custom-search'),
		inputSearch = searchContainer.querySelector('.search__input'),
		lastFocusedElement

	function init() {
		initEvents()
	}

	function initEvents() {
		openCtrl.addEventListener('click', openSearch)
		closeCtrl.addEventListener('click', closeSearch)
		document.addEventListener('keyup', function (ev) {
			// escape key.
			if (ev.keyCode === 27) {
				closeSearch()
			}
		})
	}

	function openSearch() {
		lastFocusedElement = document.activeElement
		searchContainer.classList.add('search--open')
		document.documentElement.style.overflowY = 'hidden'
		document.body.style.overflowY = 'scroll'
		inputSearch.focus()
	}

	function closeSearch() {
		searchContainer.classList.remove('search--open')
		inputSearch.blur()
		inputSearch.value = ''
		if (lastFocusedElement) {
			// restore focus
			lastFocusedElement.focus()
		}
		setTimeout(() => {
			document.documentElement.style.overflowY = 'auto'
			document.body.style.overflowY = 'auto'
		}, 350)
	}

	init()
}
